import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "cookie-consent-content" };
const _hoisted_2 = { class: "cookie-consent-header" };
const _hoisted_3 = {
    id: "cookie-consent-title",
    class: "cookie-consent-title"
};
const _hoisted_4 = {
    id: "cookie-consent-description",
    class: "cookie-consent-description"
};
const _hoisted_5 = { class: "cookie-consent-actions" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CookieInfoModal = _resolveComponent("CookieInfoModal");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
                (_ctx.visible)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["cookie-consent-modal", { 'cookie-consent-modal--bottom': _ctx.position === 'bottom' }]),
                        role: "dialog",
                        "aria-labelledby": "cookie-consent-title",
                        "aria-describedby": "cookie-consent-description"
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.t?.cookieConsent?.title || 'Cookie Consent'), 1)
                            ]),
                            _createElementVNode("p", _hoisted_4, [
                                _createTextVNode(_toDisplayString(_ctx.t?.cookieConsent?.description || 'We use cookies to enhance your browsing experience, analyze site traffic, and personalize content.') + " ", 1),
                                _createElementVNode("button", {
                                    class: "cookie-consent-link",
                                    onClick: _cache[0] || (_cache[0] =
                                        //@ts-ignore
                                        (...args) => (_ctx.onOpenInfo && _ctx.onOpenInfo(...args))),
                                    type: "button"
                                }, _toDisplayString(_ctx.t?.cookieConsent?.learnMore || 'Learn more'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("button", {
                                    class: "cookie-consent-btn cookie-consent-btn--secondary",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.onNecessaryOnly && _ctx.onNecessaryOnly(...args)))
                                }, _toDisplayString(_ctx.t?.cookieConsent?.acceptNecessary || 'Necessary Only'), 1),
                                _createElementVNode("button", {
                                    class: "cookie-consent-btn cookie-consent-btn--accept",
                                    onClick: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_ctx.onAccept && _ctx.onAccept(...args)))
                                }, _toDisplayString(_ctx.t?.cookieConsent?.acceptAll || 'Accept All'), 1)
                            ])
                        ])
                    ], 2))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }),
        _createVNode(_component_CookieInfoModal, {
            visible: _ctx.showInfoModal,
            t: _ctx.t,
            onClose: _cache[3] || (_cache[3] = ($event) => (_ctx.showInfoModal = false))
        }, null, 8, ["visible", "t"])
    ], 64));
}
